import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../views/certificate/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/certificate',
  name: 'certificate',
  component: Index,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '获奖证书',
  },
}

export default [indexRoute]

export function navigateToCertificate(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
